import { assign, createMachine } from "xstate";
import { getSetSimDigits } from "@nju/data-access-dev-tip";

interface IContext {
  orderId?: string;
  simDigits?: string;
}

type IEvent =
  | {
      type: "FETCH_SIM_DIGITS";
    }
  | {
      type: "FETCH_SIM_DIGITS_SUCCESS";
      simDigits: string;
    }
  | {
      type: "FETCH_SIM_DIGITS_ERROR";
    };

export const simSetDigitsMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          FETCH_SIM_DIGITS: {
            target: "loading",
          },
        },
      },
      loading: {
        invoke: {
          src: "fetchSimSetDigits",
        },
        on: {
          FETCH_SIM_DIGITS_SUCCESS: {
            actions: "setSimDigits",
            target: "init",
          },
          FETCH_SIM_DIGITS_ERROR: {
            target: "init",
          },
        },
      },
    },
  },
  {
    actions: {
      setSimDigits: assign<IContext, IEvent>((context, event: IEvent) => {
        if (event.type === "FETCH_SIM_DIGITS_SUCCESS") {
          return {
            simDigits: event.simDigits,
          };
        }

        return context;
      }),
    },
    services: {
      fetchSimSetDigits: (context) => {
        return async (callback) => {
          try {
            const result = (await getSetSimDigits(context.orderId)).unwrap();

            callback({
              type: "FETCH_SIM_DIGITS_SUCCESS",
              simDigits: result.code,
            });
          } catch {
            callback({
              type: "FETCH_SIM_DIGITS_ERROR",
            });
          }
        };
      },
    },
  },
);
